export const BASE_SUMMARY = {
  graph: [],
  businessTable: [],
  factoringTable: [],
  last6Months: [],
  summary: { lastMonth: [] },
};

export type SelectedFactorings = {
  name: string;
  value: number;
}[];

export type BusinessOtherFactorings = {
  [month: string]: { [factoringName: string]: number } | undefined;
  allYear?: { [factoringName: string]: number };
};

export type FactoringBusinesses = {
  [month: string]: { [businessName: string]: number } | undefined;
  allYear?: { [businessName: string]: number };
};

export type SelectedBusiness = {
  id: string;
  businessIdentifier: string;
  businessName: string;
  allYear: number;
  otherFactorings: BusinessOtherFactorings;
  [month: string]: string | number | BusinessOtherFactorings;
};

export type SelectedFactoring = {
  id: string;
  cessionaryIdentifier: string;
  cessionaryName: string;
  allYear: number;
  businesses: FactoringBusinesses;
  [month: string]: string | number | FactoringBusinesses;
};

export type CessionsSummary = {
  graph: {
    name: string;
    Total: number;
    'Total empresa': number;
  }[];
  businessTable: SelectedBusiness[];
  factoringTable: SelectedFactoring[];
  last6Months: string[];
  summary: {
    historic?: {
      Total: number;
      'Total empresa': number;
    };
    lastMonth: {
      name: string;
      value: number;
    }[];
  };
};
